/**
 * Манифесты видов ресурсов, как их отдаёт Platform (ADR-22, RP-OWN13): какие права и какие модули у вида. Клиент
 * не держит списков прав и видов у себя: форма «Добавить источник», догонка новых прав в редакторе, вкладки разделов
 * и карточка источника строятся из этого ответа. Пакет вида даёт только слова (подписи, подсказки, форму настроек).
 */

/** Модуль, который получает вид без раздела `modules` в манифесте (1С, AQSI): весь вид — одна служба. */
export const IMPLICIT_MODULE = 'main'

/** Модуль вида: какие права он даёт и какие договоры между службами обслуживает. */
export interface ConnectorModule {
  id: string
  /** Права вида, которые принадлежат этому модулю. */
  capabilities: readonly string[]
  /** Договоры службы модуля с Platform (`sync`, `receipt-analytics`…); у неявного модуля — пусто. */
  contracts: readonly string[]
}

/** Манифест вида: код, версия договора, все права вида и их разбиение по модулям. */
export interface ConnectorManifest {
  kind: string
  contractVersion: string
  capabilities: readonly string[]
  /** Всегда хотя бы один: вид без раздела модулей — один неявный `main` со всеми правами. */
  modules: readonly ConnectorModule[]
}

export interface ConnectorRegistry {
  /** Установленные виды в порядке ответа сервера. */
  all: readonly ConnectorManifest[]
  find: (kind: string) => ConnectorManifest | undefined
  /** Права вида; вида нет в ответе — пусто. */
  capabilitiesOf: (kind: string) => readonly string[]
}

export function createConnectorRegistry(manifests: readonly ConnectorManifest[]): ConnectorRegistry {
  const byKind = new Map<string, ConnectorManifest>()
  // Повтор вида отвергает декодер ответа (`decodeConnectors`); здесь данные уже проверены.
  for (const manifest of manifests) byKind.set(manifest.kind, manifest)
  return {
    all: manifests,
    find: (kind) => byKind.get(kind),
    capabilitiesOf: (kind) => byKind.get(kind)?.capabilities ?? [],
  }
}

export const EMPTY_CONNECTORS: ConnectorRegistry = createConnectorRegistry([])
